import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';


import './fonts/Ubuntu/Ubuntu-Regular.ttf';
import './fonts/Ubuntu/Ubuntu-Italic.ttf';
import './fonts/Ubuntu/Ubuntu-Medium.ttf';
import './fonts/Ubuntu/Ubuntu-MediumItalic.ttf';
import './fonts/Ubuntu/Ubuntu-Light.ttf';
import './fonts/Ubuntu/Ubuntu-LightItalic.ttf';
import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
